import { Controller } from "@hotwired/stimulus"

// The video page: fixes the WebM-without-duration quirk of MediaRecorder
// files so the scrubber works, and wires the timestamped comments (stamp the
// current second when writing, jump to the second when clicking one).
export default class extends Controller {
  static targets = ["video", "stampField", "stampLabel", "stampToggle"]

  connect() {
    this.onMeta = () => this.fixDuration()
    this.onTime = () => this.updateStamp()
    this.videoTarget.addEventListener("loadedmetadata", this.onMeta)
    this.videoTarget.addEventListener("timeupdate", this.onTime)
    this.onSubmit = (event) => this.beforeSubmit(event)
    this.element.addEventListener("submit", this.onSubmit)
  }

  disconnect() {
    this.videoTarget.removeEventListener("loadedmetadata", this.onMeta)
    this.videoTarget.removeEventListener("timeupdate", this.onTime)
    this.element.removeEventListener("submit", this.onSubmit)
  }

  fixDuration() {
    const v = this.videoTarget
    if (v.duration !== Infinity) return
    v.currentTime = 1e101
    v.addEventListener("timeupdate", () => { v.currentTime = 0 }, { once: true })
  }

  seek(event) {
    const seconds = Number(event.currentTarget.dataset.seconds || 0)
    const v = this.videoTarget
    v.currentTime = seconds
    v.play().catch(() => {})
    v.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  updateStamp() {
    if (!this.hasStampLabelTarget) return
    const s = Math.floor(this.videoTarget.currentTime || 0)
    this.stampLabelTarget.textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`
    if (this.hasStampFieldTarget) this.stampFieldTarget.value = s
  }

  beforeSubmit(event) {
    if (!this.hasStampFieldTarget || !event.target.contains(this.stampFieldTarget)) return
    if (this.hasStampToggleTarget && !this.stampToggleTarget.checked) this.stampFieldTarget.value = ""
    else this.stampFieldTarget.value = Math.floor(this.videoTarget.currentTime || 0)
  }
}
